import BaseViz from './BaseViz'
import DonutProgressChartChart from '../charts/DonutProgressChartChart'
import DonutProgressChartDataController from '../viz_behaviors/DonutProgressChartDataController'
export default class DonutProgressChartViz extends BaseViz {
  static chartClass = DonutProgressChartChart
  static dataControllerClass = DonutProgressChartDataController
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: false,
      },
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    valueFormat: {
      type: [String, Array, Function, null],
      default: null,
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
  }
}
